import { useState } from "react";
import { toast } from "sonner";
import { Sparkle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { startSocialPulseLogin, socialpulseConfigured } from "@/lib/socialpulse";

// "Continue with SocialPulse" SSO pill. Persists the return path so the user
// comes back to where they started after the round-trip.
export function SocialPulseButton({ className = "" }) {
  const [busy, setBusy] = useState(false);
  if (!socialpulseConfigured) return null;

  const go = async () => {
    try {
      setBusy(true);
      try {
        const n = new URLSearchParams(window.location.search).get("next");
        if (n && n.startsWith("/") && !n.startsWith("//")) sessionStorage.setItem("sp_next", n);
      } catch { /* ignore */ }
      await startSocialPulseLogin();
    } catch (e) {
      setBusy(false);
      toast.error(e.message || "Could not start SocialPulse sign-in.");
    }
  };

  return (
    <Button
      type="button"
      onClick={go}
      disabled={busy}
      data-testid="socialpulse-signin"
      className={`w-full gap-2 rounded-full border-0 bg-[#6d28d9] text-white hover:bg-[#5b21b6] ${className}`}
    >
      <Sparkle size={18} weight="fill" /> {busy ? "Redirecting…" : "Continue with SocialPulse"}
    </Button>
  );
}

export default SocialPulseButton;
